export interface IResetPasswordRequest {

    Checksum: string;
    Email: string;

}

export class ResetPasswordRequest implements IResetPasswordRequest {

    Checksum: string;
    Email: string;

}
